import React, { Component } from "react";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { states } from "../../../reducers/queriesStates";

class WinterMaintenceSmothFactorRouteSlider extends Component {
  onChangehandler(e) {
    const { onSetWinterRouteSmoothFactor } = this.props;
    const value = (100 - e.target.value) / 10;

    onSetWinterRouteSmoothFactor(value);
  }

  render() {
    const { winterRouteSmoothFactor, winterAreas } = this.props;
    const value = winterRouteSmoothFactor * 10;

    if (winterAreas == null || winterAreas.length === 0) {
      return null;
    }

    return (
      <div>
        <Box sx={{ width: 300 }}>
          <span>Детализация маршрута</span>
          <Slider value={100 - value} aria-label="Disabled slider" step={10} onChange={this.onChangehandler.bind(this)} />
        </Box>
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceSmothFactorRouteSlider));
